<template>
  <div ref="view">
    <Header>Vendor Forms</Header>
    <div class="tiled-bar-image"></div>
    <Main>
      <div class="flex flex-col items-center">
        <div class="container pb-8 mx-auto"
          v-if="enableVendorSelect">
          <span>View Links as</span>
          <SelectRequiredData
            v-model="requiredData"
            :vendorOptions="vendorSelectionOptions"
            :includeVendorSelect="enableVendorSelect"
            :enableVendorSelect="true">
          </SelectRequiredData>
        </div>
        <div class="w-1/2 rounded-md bg-gray-100 shadow-sm p-2">
          <div class="flex flex-col gap-2">
            <div
              v-for="linkObj in links" :key="linkObj.display">
              <a class="block text-center rounded-md bg-gray-200 p-2 text-gray-800 hover:text-blue-800 hover:bg-gray-300 visited:text-purple-800"
                v-if="linkObj.external"
                :href="linkObj.link">
                {{ linkObj.display }}
              </a>
              <router-link class="block text-center rounded-md bg-gray-200 p-2 text-gray-800 hover:text-blue-800 hover:bg-gray-300 visited:text-purple-800"
                v-else
                :to="linkObj.link">
                {{ linkObj.display }}
              </router-link>
            </div>
          </div>
        </div>
      </div>
      <!-- <p>{{ requiredData }}</p> -->
    </Main>
  </div>
</template>

<style scoped>
.tiled-bar-image {
  width: 100%;
  height: 25px;
  background-image: url("@/assets/Bar.png");
  background-repeat: repeat-x;
}
</style>

<script>
import Header from '../components/Header.vue'
import Main from '../components/Main.vue'
import SelectRequiredData from '../components/SelectRequiredData.vue'

import vendorFormsService from '../services/pages/vendorForms.js'

import user from '../services/user/user.js'
import events from '../services/events.js'

export default {
  components: {
    Header,
    Main,
    SelectRequiredData,
  },
  data() {
    return {
      requiredData: {
        vendorId: undefined,
      },
      vendorSelectionOptions: [],
      enableVendorSelect: false,

      vendor: undefined,
      linkData: undefined,
      links: [],
    }
  },
  eventCallbackIds: {},
  methods: {
    async updateUser() {
      this.user = await user.get()

      let userConfigVendorId = this.user.getConfig('vendor_id')

      this.enableVendorSelect = !userConfigVendorId
      this.requiredData.vendorId = userConfigVendorId

      if (this.enableVendorSelect) {
        this.vendorSelectionOptions = await vendorFormsService.getVendorFormOptionsFromCapability(this.user)
      }
    },
    loadFormLinks() {
      vendorFormsService.getVendorLinks()
        .then(linkData => {
          this.linkData = linkData
          this.loadVendorData(this.requiredData.vendorId)
        })
    },
    async loadVendorData(vendorId) {
      if (vendorId) {
        this.vendor = (await vendorFormsService.getVendorDetail(vendorId))
      }

      const pushInternal = (key) => {
        this.links.push({
          display: this.linkData[key].display,
          external: false,
          link: this.linkData[key].internalLink,
        })
      }

      const pushExternal = (key) => {
        this.links.push({
          display: this.linkData[key].display,
          external: true,
          link: this.linkData[key].externalLink,
        })
      }

      this.links = []
      for (var key in this.linkData) {
        if (this.linkData[key].externalLink) {
          if (this.linkData[key].capability) {
            if (this.user.can(this.linkData[key].capability)) {
              pushInternal(key)
            }
            else {
              pushExternal(key)
            }
          }

          // should probably delete this section
          else if (this.vendor !== undefined) {
            if (this.vendor?.ui_data?.vendor_forms?.internal.includes(key)) {
              pushInternal(key)
            }
            else {
              pushExternal(key)
            }
          }
          else {
            pushExternal(key)
          }
        }
        else {
          pushInternal(key)
        }
      }
    },
  },
  // computed: {},
  // watch: {},
  async mounted() {
    this.user = await user.get()

    if (!this.user.can('view_vendor_forms')) {
      this.$router.push({
        name: 'StudentList'
      })
      return
    }

    this.loadFormLinks()

    await this.updateUser()
  },
  created() {
    this.$options.eventCallbackIds.viewUpdated = events.register(
      'viewUpdated',
      () => {
        this.updateUser()
      }
    )
  },
  //beforeUnmount() {
  // eslint-disable-next-line
  beforeDestroy() {
    events.remove(
      'viewUpdated',
      this.$options.eventCallbackIds.viewUpdated
    )
  },
  watch: {
    'requiredData.vendorId': function (newValue) {
      this.loadVendorData(newValue)
    },
  }
}
</script>
